import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-rectangle-5',
  imports: [],
  templateUrl: './rectangle-5.html',
  styleUrl: './rectangle-5.scss',
})
export class Rectangle5 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
